<template>
  <div class="content" id='qa'>
    <template v-if="itemVal">
      <h2 class="m-n">{{ itemVal.title }}</h2>
      <div class="row m-t-md">
        <div class="col-xs-12 col-sm-12 pd-l-0">
          <div class="hpanel">
            <div class="panel-body">
              <div class="col-xs-4 col-sm-4 pd-l-0">
                <div class="service_logo">
                  <img
                    :src="itemVal.image"
                    width="250px"
                    height="250px"
                  />
                </div>
              </div>
              <div class="col-xs-8 col-sm-8 pd-l-0">
                <div class="service_logo">
                  <h3><a :href="itemVal.link" target="_blank" rel="noopener noreferrer">{{ itemVal.name }}</a></h3>
                  <p>{{ itemVal.company_name }}</p>
                  <p>{{ itemVal.short_description }}</p>
                </div>
              </div>
              <div class="col-xs-12 col-sm-12 pd-l-0">
                <div class="service_info">
                  <div v-html="itemVal.description"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import SettingService from '@/services/settingservice'
import EventService from '@/services/eventservice'
import eventCode from '@/common/event-code'

export default {
  props: {
    item: {
      type: Object,
      require: true
    }
  },
  data () {
    return {
      itemVal: this.item
    }
  },

  watch: {
    item (newItem) {
      this.itemVal = newItem
    }
  },

  created () {
    this.initPage(this.$route.params['id'])
  },

  methods: {
    async initPage (serviceId) {
      if (this.item === undefined) {
        const loader = this.$loading.show()
        await SettingService.getExternalService(serviceId)
          .then((response) => {
            const item = {
              name: response.name,
              title: response.title,
              image: response.image,
              company_name: response.company_name,
              short_description: response.short_description,
              url: response.url,
              description: response.description
            }
            this.itemVal = item
            let logParams = {
              name: eventCode.external_services.show_detail,
              properties: {
                service: { ...this.itemVal, id: serviceId }
              }
            }
            EventService.postTrackLog(logParams)
          })
        loader.hide()
      }
    }
  },
  mounted () {
    if (this.item !== undefined) {
      let logParams = {
        name: eventCode.external_services.show_detail,
        properties: {
          service: this.itemVal
        }
      }
      EventService.postTrackLog(logParams)
    }
  }
}
</script>

<style scoped>
.service_logo {
  position:relative;
  width: 100%;
  padding-bottom: 5%;
  overflow:hidden;
  text-align: left;
}
.service_logo>img {
  border-radius: 4%;
}
.service_info {
  margin-top: 8px;
}
</style>



// WEBPACK FOOTER //
// src/view/externalServices/ExternalServiceDetail.vue